const pl = {
  // Navigation
  nav_home: "Dom",
  nav_explore: "Badać",
  nav_workspace: "Obszar roboczy",
  ws_videos: "filmy",
  ws_untitled: "Film bez tytułu",
  // A generation that failed. The card carries these until it is dismissed.
  ws_failed_title: "Film nie powiódł się",
  ws_failed_refunded: "Twój kredyt został zwrócony",
  ws_failed_dismiss: "Odrzucać",
  ws_failed_retry: "Spróbuj ponownie",
  ws_failed_retrying: "Startowy…",
  ws_failed_banner_one: "Nie udało się wygenerować filmu",
  ws_failed_banner_many: "Nie udało się przesłać {n} filmów",
  ws_failed_banner_body: "Nic nie zostało pobrane — środki wróciły na Twoje konto. Spróbuj ponownie lub wybierz inny temat.",
  ws_empty_title: "Jeszcze nic tu nie ma.",
  ws_empty_body: "Każdy film, który nakręcisz, pojawi się tutaj, najpierw najnowszy.",
  ws_generate: "Spowodować",
  ws_composer_placeholder: "Opisz lekcję\u2026",
  ws_placeholder_hw: "Nazwij zadanie… (opcjonalnie)",
  ws_placeholder_lecture: "Nazwij wykład… (opcjonalnie)",
  ws_placeholder_self_study: "Co chcesz studiować?",
  nav_search: "Wyszukaj filmy...",
  nav_search_yours: "Przeszukaj swoje filmy...",
  nav_notifications: "Powiadomienia",
  nav_mark_all_read: "Zaznacz wszystkie jako przeczytane",
  nav_no_notifications: "Nie ma jeszcze żadnych powiadomień",
  nav_no_notifications_sub: "Powiadomimy Cię, gdy Twoje filmy będą gotowe",
  nav_upgrade: "Aktualizacja",
  nav_billing: "Rozliczenia",
  nav_settings: "Ustawienia",
  nav_contact: "Skontaktuj się z nami",
  nav_api: "API",
  nav_sign_out: "Wyloguj się",
  nav_just_now: "Właśnie",
  nav_minutes_ago: "{n}min temu",
  nav_hours_ago: "{n}h temu",
  nav_days_ago: "{n}d temu",
  nav_used_this_month: "{used} z {cap} wykorzystanych w tym miesiącu",
  // locale file, and this one is the obvious thing to reach for if a weekly bucket returns.
  nav_used_today: "{used} z {limit} wykorzystanych w tym tygodniu",
  nav_free_daily: "4 bezpłatne filmy tygodniowo",
  // Settings
  settings_title: "Ustawienia",
  settings_profile: "Profil",
  settings_change_avatar: "Zmień awatar",
  settings_cancel: "Anulować",
  settings_choose_wizard: "Wybierz swojego kreatora",
  settings_display_name: "Nazwa wyświetlana",
  settings_your_name: "Twoje imię",
  settings_save: "Ratować",
  settings_saving: "Oszczędność...",
  settings_saved: "Zapisano",
  settings_save_failed: "Nie udało się zapisać",
  settings_email: "E-mail",
  settings_notifications: "Powiadomienia",
  settings_email_notif: "Powiadomienia e-mailowe",
  settings_email_notif_desc: "Otrzymuj aktualizacje i ogłoszenia za pośrednictwem poczty elektronicznej",
  settings_language: "Język",
  settings_language_desc: "Wybierz język aplikacji i narracji wideo",
  settings_data_title: "Twoje dane",
  settings_data_desc: "Pobierz kopię danych osobowych powiązanych z Twoim kontem — w tym Twojego profilu, filmów, kursów, sesji i wiadomości pomocy. Wewnętrzne logi systemowe i pochodne dane dotyczące przetwarzania nie są uwzględniane.",
  settings_data_download: "Pobierz moje dane",
  settings_data_exporting: "Przygotowanie…",
  settings_danger: "Strefa zagrożenia",
  settings_delete_account: "Usuń konto",
  settings_delete_desc: "Usuń trwale swoje konto i wszystkie powiązane dane. Tej akcji nie można cofnąć.",
  settings_delete_confirm: "Spowoduje to trwałe usunięcie Twojego konta i wszystkich danych. Wpisz {keyword}, ​​aby potwierdzić.",
  settings_delete_placeholder: "Wpisz „USUŃ”, aby potwierdzić",
  settings_permanently_delete: "Usuń trwale",
  settings_deleting: "Usuwanie...",
  explore_watch_now: "Obejrzyj teraz",
  // One pair of strings per scene; the eyebrow and the button are shared.
  explore_no_preview: "Brak podglądu",
  explore_no_videos: "Brak dostępnych filmów. Sprawdź ponownie wkrótce!",
  explore_featured_courses: "Polecane kursy",
  course_lesson_count: "{n, plural, one {# lesson} other {# lessons}}",
  course_back_to_explore: "Powrót do Eksploruj",
  course_not_found: "Ten kurs jest niedostępny.",
  // Home Page
  home_hero: "Dowiedz się czegokolwiek,",
  home_hero_accent: "naocznie",
  home_placeholder: "Czego chcesz się nauczyć lub rozwiązać?",
  home_extracting: "Wyodrębnianie pytań...",
  home_videos_generated: "Zostanie wygenerowanych {n, plural, one {# film} few {# filmy} many {# filmów} other {# filmu}}",
  home_credits: "{n, plural, one {# kredyt} few {# kredyty} many {# kredytów} other {# kredytu}}",
  home_remaining: "pozostały w tym miesiącu",
  home_enter_prompt: "Wpisz, czego chcesz się nauczyć lub rozwiązać",
  home_popular: "Popularne lekcje",
  home_from_community: "Ze społeczności",
  home_community_sub: "Zobacz, co tworzą uczniowie",
  home_tips_label: "Od Czarodzieja Magów",
  home_tips_title: "Wskazówki i porady",
  home_tip1_title: "Bądź konkretny",
  home_tip1_desc: "Nie wpisuj całego tematu. Wybierz jeden pomysł, jedną koncepcję, jedno pytanie.",
  home_tip1_example: "Jak działa replikacja DNA w komórkach eukariotycznych",
  home_tip2_title: "Powiedz dla kogo to jest",
  home_tip2_desc: "Wyjaśnienie w gimnazjum wygląda zupełnie inaczej niż wykład na studiach.",
  home_tip2_example: "Wyjaśnij pochodne komuś, kto właśnie nauczył się algebry",
  home_tip3_title: "Powiedz Magi, czego chcesz",
  home_tip3_desc: "Przykłady, krok po kroku, zastosowania w świecie rzeczywistym – po prostu powiedz to, a Magi podąży za tobą.",
  home_tip3_example: "Obieg wody z przykładami z życia wziętymi i podsumowaniem",
  home_tip_try: "Spróbuj czegoś takiego",
  home_proven_social: "Śledź nas na Instagramie",
  home_ig_desc_1: "Nad",
  home_ig_followers: "55 000 obserwujących",
  home_ig_desc_2: "codziennie oglądaj nasze filmy o matematyce i naukach ścisłych na Instagramie. Te bębny są wykonane na tym samym silniku, którego używasz tutaj.",
  home_view_profile: "Zobacz profil",
  home_subscribe_now: "Zapisz się teraz",
  home_sub_monthly: "Miesięczny",
  home_sub_yearly: "Rocznie",
  // goes false the moment either price moves, on the surface where that matters most.
  home_sub_yearly_save: "Zaoszczędź {pct}%",
  home_sub_per_month: "/ miesiąc",
  home_sub_billed_monthly: "naliczane co miesiąc ${amount} USD",
  home_sub_processing: "Przetwarzanie...",
  home_sub_no_commitment: "Żadnego zaangażowania. Anuluj w dowolnym momencie.",
  home_sub_secured: "Zabezpieczone przez Stripe",
  home_sub_headline: "Odblokuj więcej dzięki {plan}",
  home_sub_due_now: "Termin teraz",
  home_sub_trial_label: "{days}-dniowy pełny dostęp",
  // choosing the plan directly is owed exactly what a trialist is owed.
  home_sub_monthly_terms: "Dzisiaj zostanie pobrana opłata w wysokości ${amount} w wysokości {n} filmów w tym miesiącu. W dniu {date} odnawia się po cenie ${amount}/miesiąc, chyba że najpierw anulujesz – anuluj w dowolnym momencie w obszarze Rozliczenia.",
  // frequency, states that it happens automatically, and says where to cancel.
  home_sub_trial_terms: "Dzisiaj zostanie naliczona opłata w wysokości ${trial} w wysokości {days} dni pełnego dostępu, ograniczona do {n} filmów. Okres próbny nie będzie kontynuowany w ${trial} — od dnia {date} automatycznie zmieni się on w {planName} z opłatą ${plan} miesięcznie ({full} filmy), a następnie opłata w wysokości ${plan} będzie pobierana co miesiąc, aż do momentu anulowania subskrypcji. Anuluj w dowolnej chwili opcję Rozliczenia.",
  home_sub_card: "Karta kredytowa lub debetowa",
  home_sub_billed_once_yearly: "rozliczane w wysokości ${amount} raz w roku",
  home_sub_billed_trial: "naliczana jest opłata za ${amount} USD za {days} dni, a następnie odnawiana co miesiąc po cenie ${renews}",
  home_sub_switch_plan: "Zamiast tego szukasz {plan}?",
  home_sub_replaces_plan: "Zastępuje Twój plan {plan}. Twoja data rozliczenia pozostaje taka sama — przeniesienie w górę powoduje naliczenie różnicy teraz, przejście w dół rozpoczyna się przy następnym odnowieniu.",
  home_sub_change_now: "Masz teraz plan {plan} — pobrano {amount} za różnicę.",
  home_sub_change_later: "Przejdziesz na {plan} {date}. Dziś nic nie pobieramy.",
  // the allowance changed; this one cannot.
  home_sub_feature_videos_n: "{n} filmów miesięcznie",
  // Pricing Page
  pricing_title: "Uaktualnij swój plan",
  pricing_monthly: "Miesięczny",
  pricing_yearly: "Rocznie",
  pricing_save: "Zaoszczędź 17%",
  pricing_best_value: "Najlepsza wartość",
  pricing_your_plan: "Twój aktualny plan",
  pricing_get_started: "Zacznij",
  pricing_processing: "Przetwarzanie...",
  pricing_per_month: "/miesiąc",
  pricing_billed_yearly: "Rozliczane ${amount}/rok",
  pricing_videos_month: "{n, plural, one {# film} few {# filmy} many {# filmów} other {# filmu}}/miesiąc",
  pricing_manage_cancel: "Zarządzaj lub anuluj",
  pricing_manage_unavailable: "Nie znaleźliśmy subskrypcji do zarządzania. Skontaktuj się z nami, a to naprawimy.",
  pricing_opening: "Otwór...",
  billing_autorenew_monthly: "Odnawia się automatycznie po cenie ${amount}/miesiąc, dopóki nie anulujesz.",
  billing_autorenew_yearly: "Odnawia się automatycznie po cenie ${amount}/rok, dopóki nie anulujesz.",
  billing_autorenews_on: "Automatyczne odnawianie {date} · anuluj w dowolnym momencie",
  pricing_secured: "Zabezpieczone przez Stripe",
  pricing_login_required: "Zaloguj się, aby subskrybować",
  pricing_auth_error: "Błąd uwierzytelnienia użytkownika. Spróbuj się wylogować i zalogować ponownie.",
  pricing_feature_pdf: "Ekstrakcja plików PDF i obrazów",
  pricing_feature_quality: "Model wyższej jakości",
  pricing_feature_speed: "Szybszy czas generacji",
  pricing_feature_study: "Sesje studyjne",
  pricing_free_hint: "Obecnie w planie Free",
  // Billing Page
  billing_title: "Rozliczenia",
  billing_current_plan: "Aktualny plan",
  billing_payment_failed_title: "Twój plan jest wstrzymany",
  billing_payment_failed_body: "Nie mogliśmy zebrać {amount}, więc Twój plan został wstrzymany. Zaktualizuj swoją kartę, aby uruchomić ją ponownie — my również będziemy próbować ponownie.",
  billing_payment_failed_cta: "Napraw płatność",
  billing_change_plan: "Zmień plan",
  billing_invoices: "Faktury",
  billing_loading: "Ładowanie faktur...",
  billing_no_invoices: "Nie ma jeszcze faktur",
  billing_date: "Data",
  billing_amount: "Kwota",
  billing_status: "Status",
  billing_invoice: "Faktura",
  billing_view: "Pogląd",
  // Contact Page
  contact_title: "Skontaktuj się z nami",
  contact_placeholder: "Jak możemy pomóc?",
  contact_sent_desc: "Skontaktujemy się z Tobą tak szybko, jak to możliwe.",
  contact_signin: "Zaloguj się, aby skontaktować się z pomocą techniczną.",
  // Generation Queue
  queue_title: "Kolejka",
  queue_active: "{n} aktywny",
  queue_generating: "generowanie {n}",
  queue_ready: "Gotowy do oglądania",
  queue_in_queue: "Oczekiwanie w kolejce...",
  queue_almost_ready: "Prawie gotowe...",
  queue_seconds_left: "Pozostało {n}",
  queue_minutes_left: "Pozostało {m} m {s}",
  queue_watch_now: "Obejrzyj teraz",
  queue_waiting: "Czekam w kolejce...",
  queue_empty: "Brak filmów w kolejce",
  queue_empty_sub: "Wygeneruj film, aby zobaczyć go tutaj",
  queue_clear: "Wyczyść wszystko",
  queue_total: "łącznie {n}",
  queue_first_time: "Trwa generowanie Twojego filmu",
  queue_first_time_sub: "Zwykle ~2 minuty. Gdy potrawa będzie gotowa, usłyszysz sygnał dźwiękowy.",
  // Session Expired
  session_expired: "Sesja wygasła",
  session_expired_desc: "Twoja sesja wygasła ze względów bezpieczeństwa. Aby kontynuować, zaloguj się ponownie.",
  // Cookie Banner
  cookie_text: "Używamy plików cookie do analizy ruchu w witrynie i poprawy komfortu korzystania z niej. Domyślnie ustawione są tylko niezbędne pliki cookie.",
  cookie_learn_more: "Dowiedz się więcej",
  cookie_accept: "Zaakceptuj wszystko",
  cookie_reject: "Odrzuć niepotrzebne",
  // Create Project Modal
  create_new_project: "Nowy projekt",
  create_extracting: "Ekstrahujący...",
  create_select_problems: "Wybierz Problemy",
  create_select_topics: "Wybierz Tematy",
  create_new_video: "Nowy film",
  create_new_hw: "Nowy projekt pracy domowej",
  create_new_lecture: "Nowy projekt wykładowy",
  create_new_self_study: "Nowy projekt",
  create_video: "Wideo",
  create_homework: "Praca domowa",
  create_lecture: "Wykład",
  create_self_study: "Projekt",
  create_video_sub: "Wygeneruj wideo",
  create_hw_sub: "Prześlij zadanie domowe",
  create_lecture_sub: "Prześlij slajdy",
  create_self_study_sub: "Wybierz tematy",
  create_video_prompt: "Co powinien wyjaśnić film?",
  create_project_title: "Tytuł projektu",
  create_video_hint: "Będzie ono używane zarówno jako tytuł, jak i zachęta do Twojego filmu.",
  create_drop_hw: "Zostaw tutaj swoją pracę domową",
  create_drop_lecture: "Upuść tutaj slajdy z wykładów",
  create_file_types: "PDF, PNG, JPG, HEIC",
  // Shown over the composer while a file is being dragged onto it.
  composer_drop_hint: "Upuść, aby rozpocząć projekt",
  create_reading_hw: "Czytanie twojej pracy domowej",
  create_reading_lecture: "Czytając Twój wykład",
  create_finding_problems: "Znajdowanie i wyodrębnianie problemów...",
  create_finding_topics: "Wyciąganie tematów...",
  create_add_video: "Dodaj kolejny film",
  create_add_more_files: "Dodaj więcej plików",
  create_starting: "Rozpoczęcie generacji...",
  create_generate_video: "Wygeneruj film \u00B7 1 kredyt",
  create_generate_n: "Wygeneruj {n, plural, one {# film} few {# filmy} many {# filmów} other {# filmu}} \u00B7 {n, plural, one {# kredyt} few {# kredyty} many {# kredytów} other {# kredytu}}",
  create_create_project: "Utwórz projekt \u00B7 {n, plural, one {# kredyt} few {# kredyty} many {# kredytów} other {# kredytu}}",
  create_no_problems: "Nie udało się znaleźć żadnych problemów. Spróbuj uzyskać wyraźniejsze zdjęcie lub inną stronę.",
  create_no_topics: "Nie udało się znaleźć żadnych tematów. Spróbuj uzyskać wyraźniejsze zdjęcie lub inny plik.",
  create_error: "Coś poszło nie tak. Spróbuj ponownie.",
  create_extract_daily_limit: "To już wszystkie dokumenty na dzisiaj. Więcej jutro.",
  create_video_topic_placeholder: "Temat filmu {n.}, np. „Wartości własne i wektory własne”",
  video_share: "Udział",
  // and made the two indistinguishable.
  video_followup_placeholder: "Wygeneruj wideo uzupełniające...",
  video_chip_simpler: "Wyjaśnij prościej",
  video_chip_harder: "Trudniejszy przykład",
  video_chip_real_world: "Wykorzystanie w świecie rzeczywistym",
  // spends a credit generating a new one.
  video_ask_title: "Zapytaj o ten film",
  video_ask_cta: "Porozmawiaj o tym",
  video_ask_placeholder: "Zadaj pytanie...",
  video_ask_thinking: "Myślący...",
  video_ask_close: "Zamknąć",
  video_ask_chip_explain: "Wyjaśnij tę część",
  video_ask_chip_example: "Podaj przykład",
  video_ask_chip_why: "Dlaczego to działa?",
  video_ask_limit_reached: "Osiągnąłeś dzisiejszy limit pytań. Jutro się zresetuje.",
  video_up_next: "Dalej",
  video_no_suggested: "Nie ma jeszcze sugerowanych filmów",
  video_untitled: "Wideo bez tytułu",
  video_created_recently: "Utworzono niedawno",
  video_just_now: "Właśnie",
  video_minutes_ago: "{n, plural, one {# minutę} few {# minuty} many {# minut} other {# minuty}} temu",
  video_hours_ago: "{n, plural, one {# godzinę} few {# godziny} many {# godzin} other {# godziny}} temu",
  video_days_ago: "{n, plural, one {# dzień} few {# dni} many {# dni} other {# dnia}} temu",
  video_weeks_ago: "{n, plural, one {# tydzień} few {# tygodnie} many {# tygodni} other {# tygodnia}} temu",
  video_months_ago: "{n, plural, one {# miesiąc} few {# miesiące} many {# miesięcy} other {# miesiąca}} temu",
  video_years_ago: "{n, plural, one {# rok} few {# lata} many {# lat} other {# roku}} temu",
  video_unknown_date: "Nieznana data",
  video_download_error: "Coś poszło nie tak. Spróbuj ponownie.",
  // Search Results
  search_no_results: "Nie znaleziono żadnych wyników",
  search_no_results_for: "Nie znaleziono wyników dla „{query}”",
  search_all_videos: "Przeszukaj wszystkie filmy",
  search_enter_term: "Wprowadź wyszukiwane hasło, aby znaleźć filmy",
  search_retry: "Ponów wyszukiwanie",
  auth_continue_google: "Kontynuuj z Google",
  // sentence, and the box ships unticked — a pre-ticked box is not consent.
  home_sub_waiver: "Natychmiast rozpocznij mój dostęp. Rozumiem, że oznacza to, że rezygnuję z mojego {days}-dniowego prawa do odstąpienia od umowy i otrzymania zwrotu pieniędzy.",
  home_sub_waiver_required: "Potwierdź, aby kontynuować.",
  home_sub_agree_prefix: "Kontynuując, zgadzasz się z naszymi",
  // floor is 13 — if that clause changes, this string and DIGITAL_CONSENT_AGE move with it.
  auth_min_age: "Aby korzystać z Magi, musisz mieć ukończone {age}.",
  auth_agree_prefix: "Logując się wyrażasz zgodę na nasze",
  auth_terms: "Warunki świadczenia usług",
  auth_and: "I",
  auth_privacy: "Polityka prywatności",
  auth_email_optin: "Wysyłaj mi wskazówki i aktualizacje",
  // Auth modal (Google + email/password)
  auth_signin_title: "Zaloguj się do Magi",
  auth_signin_desc: "Rozpocznij od miejsca, w którym skończyłeś.",
  auth_signup_title: "Utwórz swoje konto",
  auth_signup_desc: "Na początek za darmo, bez karty.",
  auth_or: "Lub",
  auth_continue_email: "Kontynuuj za pomocą poczty elektronicznej",
  auth_signing_in: "Logowanie…",
  auth_working: "Tylko chwilka…",
  auth_email_placeholder: "Adres e-mail",
  auth_password_placeholder: "Hasło",
  auth_signin_submit: "Zalogować się",
  auth_signup_submit: "Utwórz konto",
  auth_no_account: "Nowy tutaj?",
  auth_signup_link: "Utwórz konto",
  auth_have_account: "Masz już konto?",
  auth_signin_link: "Zalogować się",
  auth_forgot_password: "Zapomniałeś hasła?",
  auth_reset_title: "Zresetuj swoje hasło",
  auth_reset_desc: "Wyślemy Ci e-mailem link umożliwiający ustawienie nowego.",
  auth_reset_submit: "Wyślij link resetujący",
  auth_reset_sent: "Sprawdź, czy w skrzynce e-mail znajduje się link resetujący.",
  auth_back_to_signin: "Wróć do logowania",
  // Full-screen wall shown to a signed-in account that has not confirmed its address.
  verify_wall_title: "Potwierdź swój adres e-mail, aby kontynuować",
  verify_wall_desc: "Wysłaliśmy link potwierdzający na adres {email}. Kliknij i wróć tutaj.",
  verify_wall_check: "Potwierdziłem to",
  verify_wall_checking: "Kontrola...",
  verify_wall_still_unverified: "Jeszcze nie potwierdzone. Kliknij link w wiadomości e-mail, a następnie spróbuj ponownie.",
  verify_wall_resend: "Wyślij link ponownie",
  verify_wall_resent: "Wysłano. Sprawdź swoją skrzynkę odbiorczą i folder ze spamem.",
  verify_wall_wrong_account: "Złe konto? Wyloguj się",
  // The screen the confirmation LINK lands on, replacing Firebase's unbranded handler page.
  verify_action_working_title: "Potwierdzam Twój e-mail",
  verify_action_working_desc: "Jedna chwila.",
  verify_action_done_title: "Wszystko gotowe",
  verify_action_done_desc: "Twój e-mail został potwierdzony. Witamy w Magi.",
  verify_action_done_cta: "Zacznij się uczyć",
  verify_action_failed_title: "Ten link nie zadziałał",
  verify_action_failed_desc: "Być może został już wykorzystany lub utracił ważność. Wróć i wyślij sobie nowy.",
  verify_action_failed_cta: "Powrót do Magi",
  // Wall copy — each surface names what signing in actually gets you
  auth_watch_title: "Zaloguj się, aby obejrzeć",
  auth_watch_desc: "Utwórz darmowe konto, aby odtworzyć ten film.",
  auth_watch_ready_title: "Twój film jest gotowy",
  auth_watch_ready_desc: "Zaloguj się, aby go obejrzeć — zostanie on zapisany na Twoim koncie.",
  // rather than saying "sign in" twice — the specific ask converts, the generic one nags.
  auth_download_title: "Zaloguj się, aby pobrać",
  auth_download_desc: "Utwórz bezpłatne konto, aby zapisać ten film.",
  auth_ask_title: "Zaloguj się, aby zapytać",
  auth_ask_desc: "Utwórz bezpłatne konto, aby zapytać o ten film.",
  auth_browse_title: "Zaloguj się, aby przeglądać",
  auth_browse_desc: "Utwórz bezpłatne konto, aby przeglądać każdą lekcję.",
  auth_workspace_title: "Zaloguj się, aby zobaczyć swoją pracę",
  auth_workspace_desc: "Twoje lekcje i projekty znajdują się na Twoim koncie.",
  auth_generate_title: "Zaloguj się, aby dalej tworzyć",
  auth_generate_desc: "Konta bezpłatne otrzymują codziennie film.",
  video_restricted: "Ten film nie jest jeszcze dostępny.",
  // Share sheet
  share_title: "Udostępnij ten film",
  share_desc_mobile: "Opublikuj go w swojej relacji, wyślij znajomemu lub skopiuj link.",
  share_desc_desktop: "Skopiuj link lub pobierz film, aby opublikować go ze swojego telefonu.",
  share_to_apps: "Udostępnij na Instagramie i nie tylko",
  share_copy_link: "Skopiuj link",
  share_copied: "Link skopiowany",
  share_download: "Pobierz wideo",
  share_preparing: "Przygotowanie…",
  share_watermark_note: "Udostępnione filmy obejmują magiacademy.com",
  // Welcome Modal (post-signup)
  welcome_title: "Witamy w Magii",
  welcome_subtitle: "Na początek masz 4 bezpłatne filmy.",
  welcome_optin_reward: "+1 darmowy film",
  welcome_continue: "Kontynuować",
  age_gate_continue: "Kontynuować",
  age_gate_saving: "Oszczędność...",
  // Landing Page
  landing_hero: "Wpisz temat.",
  landing_hero2: "Skorzystaj z lekcji wideo.",
  landing_subtitle: "Magi w ciągu kilku minut zamienia dowolny temat w pięknie animowany film z narracją. Bez filmowania, bez montażu, bez specjalistycznej wiedzy.",
  landing_signup_google: "Zarejestruj się w Google",
  landing_signing_in: "Logowanie...",
  landing_chat_bubble: "Jak GPS wykorzystuje teorię względności?",
  landing_stats_title: "Zaufali uczniowie na całym świecie",
  landing_stat_videos: "3000+",
  landing_stat_videos_desc: "Wygenerowano filmy",
  landing_stat_languages_desc: "Języki",
  landing_stat_speed: "~1 minuta",
  landing_stat_speed_desc: "Czas generacji",
  landing_feature_lecture_title: "Upuść notatki z wykładów i pobierz filmy",
  landing_feature_lecture_desc: "Prześlij swoje slajdy lub notatki. Magi wyciąga każdy temat i generuje objaśnienie wideo dla każdego z nich.",
  landing_feature_hw_title: "Utknąłeś w odrabianiu zadań domowych? Prześlij to.",
  landing_feature_hw_desc: "Upuść zestaw problemów, a Magi wyodrębni każdy problem, a następnie przeprowadzi Cię przez rozwiązanie w filmie krok po kroku.",
  landing_feature_chat_title: "Zadawaj pytania podczas oglądania",
  landing_feature_chat_desc: "Do każdego filmu dołączony jest nauczyciel AI, z którym możesz rozmawiać. Zadawaj dodatkowe pytania, uzyskaj głębsze wyjaśnienia lub poproś o nowy film dotyczący konkretnej części, którą chcesz lepiej zrozumieć.",
  landing_feature_lang_title: "Ucz się w swoim języku",
  landing_feature_lang_desc: "Magi generuje filmy w języku angielskim, hiszpańskim, hindi, chińskim, japońskim i innych. Wpisz temat w dowolnym języku i uzyskaj lekcję z pełną narracją w tym języku.",
  landing_cta_title: "Rozpocznij naukę w kilka sekund",
  landing_cta_google: "Kontynuuj z Google",
  // Onboarding Bubbles
  onboarding_step1: "To nie jest chatbot. Wpisz temat, a wygeneruję dla Ciebie pełną lekcję wideo!",
  onboarding_step2: "Lub prześlij plik PDF lub zdjęcie \u2014 Zamienię każdy problem w rozwiązanie wideo krok po kroku",
  onboarding_step3: "Naciśnij przycisk Start, a Twój film dołączy do kolejki. Możesz kontynuować przeglądanie podczas renderowania!",
  onboarding_generating: "To twoja lekcja, którą wyciągasz – kilka minut. Kontynuuj przeglądanie, jeśli chcesz; wyląduje właśnie tutaj, kiedy będzie gotowy.",
  onboarding_skip: "Pominąć",
  onboarding_next: "Następny",
  onboarding_done: "Rozumiem!",
  // Generating Cards Row
  generating_label: "Generowanie",
  // Lecture Session (Self Study)
  lecture_loading: "Załadunek...",
  lecture_fallback_title: "Wykład",
  lecture_building: "Tworzenie filmu...",
  lecture_building_time: "Zwykle zajmuje to 2–4 minuty",
  lecture_failed: "Generowanie wideo nie powiodło się",
  lecture_no_video: "Nie ma jeszcze wideo",
  lecture_followup: "Podejmować właściwe kroki",
  lecture_now_playing: "Teraz gram",
  lecture_tab_videos: "Filmy",
  lecture_tab_chat: "Pogawędzić",
  lecture_chat_empty: "Zapytaj o cokolwiek na ten temat",
  lecture_chat_chip1: "Wyjaśnij prosto",
  lecture_chat_chip2: "Podaj przykład",
  lecture_chat_chip3: "Dlaczego jest to przydatne?",
  lecture_chat_placeholder: "Zapytaj w tym temacie...",
  lecture_followup_placeholder: "Dodaj kolejny film...",
  lecture_chat_error: "Nie udało mi się tego przetworzyć. Spróbuj ponownie.",
  lecture_chat_generic_error: "Coś poszło nie tak. Spróbuj ponownie.",
  // Home shortcuts — square cards that jump to the Workspace composer preset to a mode
  home_sc_hw_title: "Praca domowa w formacie PDF",
  home_sc_hw_desc: "Prześlij zestaw problemów, uzyskaj działający film na każde pytanie",
  home_sc_lecture_title: "Wykład PDF",
  home_sc_lecture_desc: "Zamień slajdy lub notatki w serię lekcji",
  home_sc_course_title: "Utwórz kurs",
  home_sc_course_desc: "Zaplanuj sekwencję lekcji na jeden temat",
  // Misc
  generic_error: "Coś poszło nie tak. Spróbuj ponownie.",
  loading: "Załadunek...",
};

export default pl;
